import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CONFIG } from "../Config";
import action from "../redux/action";
import { _IMAPI } from "../assets/js/imapi";
import { useNavigate } from "react-router-dom";


const useDetectToken = () => {

    const dispatch = useDispatch();
    const toastOpen = useSelector(state => state.toastOpen);
    let token = localStorage.getItem("AUTH_TOKEN");
    const navigate = useNavigate();

    useEffect(() => {

        const favicon = document.querySelector('link[rel="icon"]');
        favicon.href = CONFIG.FAVICON;

        let timeoutID = "";

        if (toastOpen) {
            timeoutID = setTimeout(() => {
                dispatch(action.storeToastStatus(false));
                clearTimeout(timeoutID);
            }, 5000)
        }

        return () => {
            clearTimeout(timeoutID);
        };

    }, [toastOpen]);


    return {
        token,
        toastOpen

    }


}

export default useDetectToken